export default __webpack_public_path__ + "static/media/como-registrarse.e7ee4fa5.pdf";